import FooterMenu from './FooterMenu';
export default class FooterSection {
    static fromPartial(partial) {
        var _a, _b, _c, _d, _e, _f;
        const section = new FooterSection();
        const translation = (_a = partial.translations) === null || _a === void 0 ? void 0 : _a.pop();
        section.copyrightText = (_b = translation === null || translation === void 0 ? void 0 : translation.copyright_text) !== null && _b !== void 0 ? _b : '';
        section.email = (_c = translation === null || translation === void 0 ? void 0 : translation.email) !== null && _c !== void 0 ? _c : '';
        section.address = (_d = translation === null || translation === void 0 ? void 0 : translation.address) !== null && _d !== void 0 ? _d : '';
        section.postalCode = (_e = translation === null || translation === void 0 ? void 0 : translation.postal_code) !== null && _e !== void 0 ? _e : '';
        section.contacts = (_f = translation === null || translation === void 0 ? void 0 : translation.contacts) !== null && _f !== void 0 ? _f : '';
        if (partial.footer_menu) {
            section.menuItems = new Array();
            for (const menuItem of partial.footer_menu) {
                if (menuItem === null || menuItem === void 0 ? void 0 : menuItem.menus_id) {
                    section.menuItems.push(FooterMenu.fromPartial(menuItem === null || menuItem === void 0 ? void 0 : menuItem.menus_id));
                }
            }
        }
        return section;
    }
}
